// A moldura da área de trabalho de desembolso (design D1/D2): a ORDEM dos blocos mora
// aqui, uma vez só, e o conteúdo de cada bloco vem de quem usa — `Disbursement` (módulo
// Ampli) e `Advancements` (tela legada do Sienge). Assim as duas políticas não têm como
// divergir na ordem, que é o que o cliente pediu:
//
//   1. estado, origem, cobertura e gráfico do desembolso da obra   (`status` + `chart`)
//   2. EAP do empreendimento e catálogo de insumos, o detalhamento (`detail`)
//   3. ajustes e regras já criados                                 (`created`)
//
// Revisão de 13/10/2026: os já criados desceram para baixo do detalhamento, a pedido do
// produto — a busca e o filtro da EAP encurtam a rolagem até eles.
//
// mais um slot de painel (`panel`) para os recursos dedicados que abrem por cima da área
// de trabalho (a IA), fora do fluxo dos três blocos.
//
// A SELEÇÃO DE MESES vive aqui, não em quem a usa: `Set<"AAAA-MM">`, zerada na troca de
// obra (a moldura é remontada por `key={workId}`, então nem um render com a seleção velha
// chega a existir). Cada slot recebe a seleção por função — `chart` para marcar/desmarcar
// barras, `detail` para recortar a lista — sem nenhuma requisição por clique de mês.
import { useCallback, useMemo, useState } from "react";

const render = (slot, context) =>
  typeof slot === "function" ? slot(context) : slot;

const Workspace = ({ workId, status, chart, created, detail, panel }) => {
  const [selectedMonths, setSelectedMonths] = useState(() => new Set());

  const toggleMonth = useCallback((month) => {
    setSelectedMonths((current) => {
      const next = new Set(current);
      if (next.has(month)) next.delete(month);
      else next.add(month);
      return next;
    });
  }, []);

  const clearMonths = useCallback(() => setSelectedMonths(new Set()), []);

  const context = useMemo(
    () => ({
      workId,
      selectedMonths,
      hasSelection: selectedMonths.size > 0,
      toggleMonth,
      clearMonths,
    }),
    [workId, selectedMonths, toggleMonth, clearMonths],
  );

  return (
    <div className="ampli-disbursement-page ampli-disbursement-workspace">
      <section
        className="ampli-disbursement-workspace__block ampli-disbursement-workspace__block--status"
        data-block="status"
        aria-label="Situação e curva do desembolso"
      >
        {render(status, context)}
        {render(chart, context)}
      </section>
      <section
        className="ampli-disbursement-workspace__block ampli-disbursement-workspace__block--detail"
        data-block="detail"
        aria-label="Detalhamento do desembolso"
      >
        {render(detail, context)}
      </section>
      <section
        className="ampli-disbursement-workspace__block ampli-disbursement-workspace__block--created"
        data-block="created"
        aria-label="Ajustes e regras já criados"
      >
        {render(created, context)}
      </section>
      {render(panel, context)}
    </div>
  );
};

/** `key={workId}`: a seleção de meses (e todo estado dos slots) não atravessa a troca de obra. */
const DisbursementWorkspace = (props) => (
  <Workspace key={props.workId ?? "no-work"} {...props} />
);

export default DisbursementWorkspace;
